import AutoNumberServices from "@/services/AutoNumberServices.js";

export default {
  getAutoNumberList: AutoNumberServices.getList
}